import * as React from 'react';
import "./App.css";
import { AuthProvider } from "./modules/security/AuthContext";
import MainLayout from "./modules/common/MainLayout";
import { ThemeProvider } from "./modules/common/ThemeContext";

function App() {
  return (
      <AuthProvider>
        <ThemeProvider>
          <MainLayout />
        </ThemeProvider>
      </AuthProvider>
  );
}

export default App;